export class OrganizationPhone {

  orgUnitId!: string;
  phoneNumber!: string;
  relationshipTypeCode!: string;
  relationshipTypeDescription!: string;

}
